// Inline cell preview popover. Floats below the hovered cell with a
// pretty-printed JSON / long string when the cell content is
// truncated in the table. Position is locked to the cell's bounding
// rect at the moment of hover-enter, so subsequent scrolling can
// drag it offscreen — that's fine, the operator's mouseleave on the
// cell hides it anyway (pointerEvents: 'none' so the popover never
// steals hover from the underlying cell). Extracted from
// DataSurfaceV3 during the agent-velocity refactor.

import * as React from 'react';
import { formatPreview } from './data-surface-utils';

export function CellHoverPreview({
  state,
  rows,
}: {
  state: { rowIdx: number; col: string; left: number; top: number } | null;
  rows: Array<Record<string, unknown>> | null | undefined;
}): React.ReactElement | null {
  if (!state || !rows || !rows[state.rowIdx]) return null;
  return (
    <div
      style={{
        position: 'fixed',
        left: Math.min(state.left, window.innerWidth - 520),
        top: Math.min(state.top, window.innerHeight - 320),
        background: 'var(--bg-elev)',
        border: '1px solid var(--accent-line)',
        borderRadius: 4,
        padding: '8px 12px',
        fontSize: 11.5,
        fontFamily: 'var(--mono)',
        color: 'var(--ink)',
        maxWidth: 500,
        maxHeight: 300,
        overflow: 'auto',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        boxShadow: '0 6px 20px oklch(0.18 0.01 250 / 0.22)',
        zIndex: 1000,
        pointerEvents: 'none',
      }}
    >
      <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--ink-3)', marginBottom: 4 }}>
        {state.col}
      </div>
      {formatPreview(rows[state.rowIdx]![state.col])}
    </div>
  );
}
